module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1501-55db6fdfa487d14e65f50b0102b281d5.png";